import { Validator } from '@vista-digital/validator';
import { nonEmptyStringValidator } from './string';
import { translationValidator } from './translation';
export const translatableValidator = Validator.object({
    text: nonEmptyStringValidator,
    translations: Validator.array({ items: translationValidator })
});
